export const RequiredMarker = () => (
  <span style={{ color: 'var(--destructive)' }} aria-hidden="true">
    {' *'}
  </span>
);
